export default "__VITE_ASSET__D$BkCnz___"